'use client';

import dynamic from 'next/dynamic';

const AuthContent = dynamic(() => import('./auth-content'), { ssr: false });

export default function AuthPage() {
  return <AuthContent />;
}
